// Auth-related TypeScript types - matches backend UserProfileResponse exactly

export interface SignupData {
  contentType?: string
  websiteUrl?: string
  youtubeUrl?: string
  text?: string
  durationMinutes?: number
  style?: string
  source?: string
}

export interface UserProfileResponse {
  id: string
  name: string
  email: string
  plan: string
  pendingPlanDowngrade?: string
  isAdmin: boolean
  signupData?: SignupData
  onboardingCompleted: boolean
  emailVerified: boolean
  hasGeneratedFullPodcastAudio: boolean
  freeSeriesEpisodeUsed: boolean
  recommendations?: Recommendation[]
  // New usage fields
  creditsCap?: number
  creditsUsed?: number
  creditsRemaining?: number
  bonusCredits?: number
  // Weekly-plan episode usage fields (only set when on a weekly plan)
  episodesPerCycle?: number
  episodesUsedThisCycle?: number
  episodesRemaining?: number
  bonusEpisodes?: number
  researchEpisodesRemaining?: number
  /** Selected episode duration for the user's weekly plan and episode top-ups (10/20/30 min). */
  episodeDurationMinutes?: number
}

export interface Recommendation {
  newPrompt: string
  title: string
  description: string
}

// Plan constants - matches backend PlanConstants
export const PLAN_CONSTANTS = {
  FREE_PLAN: 'free',
  STARTER_PLAN: 'starter', 
  GROWTH_PLAN: 'growth',
  SCALE_PLAN: 'scale',
} as const

export type PlanType = typeof PLAN_CONSTANTS[keyof typeof PLAN_CONSTANTS]

export interface AuthState {
  user: UserProfileResponse | null
  isAuthenticated: boolean
  isLoading: boolean
}
